<template>
  <v-card>
    <v-container grid-list-xl>
      <v-layout>
        <v-flex xs12>
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step step="1" :complete="e1 > 1"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2" :complete="e1 > 2"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3" :complete="e1 > 3"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="4" :complete="e1 > 4"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="5" :complete="e1 > 5"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="6" :complete="e1 > 6"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="7" :complete="e1 > 7"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="8" :complete="e1 > 8"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="9" :complete="e1 > 9"></v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="10" :complete="e1 > 10"></v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                <tutorial-step1 v-on:continue="e1++"></tutorial-step1>
              </v-stepper-content>
              <v-stepper-content step="2">
                <tutorial-step2 v-on:continue="e1++" v-on:back="e1--"></tutorial-step2>
              </v-stepper-content>
              <v-stepper-content step="3">
                <tutorial-step3 v-on:continue="e1++" v-on:back="e1--"></tutorial-step3>
              </v-stepper-content>
              <v-stepper-content step="4">
                <tutorial-step4 v-on:continue="e1++" v-on:back="e1--"></tutorial-step4>
              </v-stepper-content>
              <v-stepper-content step="5">
                <tutorial-step5 v-on:continue="e1++" v-on:back="e1--"></tutorial-step5>
              </v-stepper-content>
              <v-stepper-content step="6">
                <tutorial-questionnaires-list v-on:continue="e1++" v-on:back="e1--"></tutorial-questionnaires-list>
              </v-stepper-content>
              <v-stepper-content step="7">
                <tutorial-step7 v-on:continue="e1++" v-on:back="e1--"></tutorial-step7>
              </v-stepper-content>
              <v-stepper-content step="8">
                <tutorial-step-summary v-on:continue="e1++" v-on:back="e1--"></tutorial-step-summary>
              </v-stepper-content>
              <v-stepper-content step="9">
                <tutorial-step-decision v-on:continue="e1++" v-on:back="e1--"></tutorial-step-decision>
              </v-stepper-content>
              <v-stepper-content step="10">
                <tutorial-step-finished v-on:finish="finish" v-on:back="e1--"></tutorial-step-finished>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
  import moment from 'moment'
  import TutorialStep1 from '@/components/tutorial/TutorialStep1'
  import TutorialStep2 from '@/components/tutorial/TutorialStep2'
  import TutorialStep3 from '@/components/tutorial/TutorialStep3'
  import TutorialStep4 from '@/components/tutorial/TutorialStep4'
  import TutorialStep5 from '@/components/tutorial/TutorialStep5'
  import TutorialStep7 from '@/components/tutorial/TutorialStep7'
  import TutorialQuestionnairesList from '@/components/tutorial/TutorialQuestionnairesList'
  import TutorialStepSummary from '@/components/tutorial/TutorialStepSummary'
  import TutorialStepDecision from '@/components/tutorial/TutorialStepDecision'
  import TutorialStepFinished from '@/components/tutorial/TutorialStepFinished'
  export default {
    components: {
      TutorialStepSummary,
      TutorialStepFinished,
      TutorialStepDecision,
      TutorialQuestionnairesList,
      TutorialStep7,
      TutorialStep5,
      TutorialStep4,
      TutorialStep3,
      TutorialStep2,
      TutorialStep1},
    name: 'tutorial',
    data () {
      return {
        e1: 1,
        version: this.$auth.user().version,
        headersTeacher: [
          { text: this.$t('questionnaires.headers.DATE'), value: 'creationDate' },
          { text: this.$t('questionnaires.headers.LEVEL'), align: 'left', value: 'level' },
          { text: this.$t('questionnaires.headers.GROUP'), align: 'left', value: 'group' },
          { text: this.$t('questionnaires.headers.SUBJECT'), align: 'left', value: 'subject' },
          { text: this.$t('questionnaires.headers.ACTIVITY'), align: 'left', value: 'activityDescription' }
        ],
        questionnaires: [
          {id: 1, creationDate: '2017-01-01', level: 1, group: 1, subject: 'Tutoria', activityDescription: 'Durant la classe vam adoptar un format en rotllana i els alumnes explicaven què havien fet durant el cap de setmana'}
        ],
        questionnaireItems: [
          { questionnaireId: 1, itemId: 30, itemOrder: 1, isAnswered: false, answer: null }
        ]
      }
    },
    methods: {
      finish: function () {
        this.$emit('end-tutorial')
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('DD/MM/YYYY')
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tutorial/Tutorial.vue